import type { Action } from '../contract';
import { cn } from '../lib/cn';
import { Button } from '../primitives/Button';

/**
 * Attention row ported from the prototype. A severity dot, a title, a plain
 * line, and a Fix button. Severity here is derived from the action's estimated
 * lift, which is honest: bigger measured basis → louder.
 */
export function AttentionRow({ action, onFix }: { action: Action; onFix: () => void }) {
  const sev = action.estLift === null ? 'warn' : action.estLift >= 6 ? 'crit' : 'warn';
  return (
    <div className="flex items-start gap-3 border-t border-gray-200 py-3.5 first:border-t-0 first:pt-0">
      <span
        className={cn(
          'mt-1.5 h-2 w-2 flex-shrink-0 rounded-full',
          sev === 'crit' ? 'bg-rose-500' : 'bg-amber-500',
        )}
      />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-gray-900">{action.title}</p>
        <p className="mt-0.5 text-sm text-gray-500">{action.body}</p>
      </div>
      <Button variant="secondary" size="sm" onClick={onFix} className="flex-shrink-0">
        Fix
      </Button>
    </div>
  );
}
